const ACTION = {
    UPDATE_CONTACT_EMAIL: 'UPDATE_CONTACT_EMAIL',
    UPDATE_CONTACT_EMAIL_ERROR_TEXT: 'UPDATE_CONTACT_EMAIL_ERROR_TEXT',
    UPDATE_CONTACT_EMAIL_NEED: 'UPDATE_CONTACT_EMAIL_NEED',
}

export default ACTION;